import * as React from "react"
import { AppState } from "../../../store/types"
import { useSelector } from "react-redux"
import IParkingAvailabilityModel from "../../../interfaces/IParkingAvailabilityModel"
import { setParkingAvailabilityModel } from "../../../store/devdocs/actions"
import { mockData } from "../../../mock-data/mockData"
import { useDispatch } from "react-redux"

export function TestButton() {
  const { dateTime, facilityName } = useSelector(
    (state: AppState) => state.devDocs
  )
  const dispatch = useDispatch()
  const fetchParkingOrderCalculation = async () => {

    // PRODUCTION API URL (POST to a serverless function)
    const response = await fetch(`/.netlify/functions/get-app-parking-order-calculation`, {
      method: 'POST',
      body: JSON.stringify({dateTime, facilityName})
    })

    // DEV API URL (save for reference)
    // const response = await fetch(
    //   `http://localhost:5000/AppParkingOrderCalculation/2021-03-20T10:09:35.116Z/Aigle`
    // )
    const data = await response.json() as IParkingAvailabilityModel
    dispatch(setParkingAvailabilityModel(data))
  }

  return (
    <div>
      <p>Availability Endpoint:</p>
      <p>{`http://139.59.151.1/api/AppParkingOrderCalculation/${dateTime.toISOString()}/${facilityName}`}</p>
      <p>Forecast Endpoint:</p>
      <p>{`http://139.59.151.1/api/ParkingAvailability/ChartData/${dateTime.toISOString()}/${facilityName}`}</p>
      
      <button
        className="btn btn-primary mb-3"
        onClick={fetchParkingOrderCalculation}
      >
        Call Endpoints
      </button>
    </div>
  )
}
